module.exports = __webpack_public_path__ + "fd0a4c41019e610c706c9e9faf2d228c.fbx";